import { router_config, RouterMenuProps } from '../configs/route.config'

export type SidebarItem = {
  id: number
  icon: string
  name: string
  value?: number | string
  divider?: boolean
  path?: string
  dropdown?: {
    id: number
    name: string
    value?: number
    path?: string
  }[]
}

export interface SidebarItems {
  id: number
  icon?: string
  name: string
  path: string
  divider?: boolean
}

// export const sidebarList: SidebarItem[] = [
//   {
//     id: 1,
//     icon: 'dashboard-icon',
//     name: 'Dashboard',
//     path: '/dashboard',
//   },
//   // {
//   //   id: 2,
//   //   icon: 'settings',
//   //   name: 'Master Settings ',
//   //   value: ' drop-arrow',
//   //   path: '/settings',

//   //   dropdown: [
//   //     { id: 0, name: 'Admins', path: '/admin' },
//   //     { id: 1, name: 'Global Roles', path: '/global' },
//   //     { id: 2, name: 'Data Management', path: '/data-management' },
//   //     // { name: 'Data Management', value: 22 },
//   //   ],
//   // },
//   // {
//   //   id: 3,
//   //   icon: 'customer-icon',
//   //   name: 'Customer',
//   //   path: '/customer',
//   // },
//   // {
//   //   id: 4,
//   //   icon: 'subscription-icon',
//   //   name: 'Subscription Plans',
//   //   value: 77,
//   //   path: '/subscription',
//   // },
//   // {
//   //   id: 5,
//   //   icon: 'discount-icon',
//   //   name: 'Discounts Coupons',
//   //   value: 3,
//   //   path: '/discount',
//   // },
//   // {
//   //   id: 6,
//   //   icon: 'payment-icon',
//   //   name: 'Payments',
//   //   value: 12,
//   //   path: '/payment',
//   // },
//   // {
//   //   id: 8,
//   //   icon: 'export-icon',
//   //   name: 'Exports',
//   //   value: 32,
//   //   divider: true,
//   //   path: '/export',
//   // },
//   // {
//   //   id: 9,
//   //   icon: 'support-icon',
//   //   name: 'Support & Requests',
//   //   value: 12,
//   //   path: '/support',
//   // },
// ]

export const sidebarList: SidebarItems[] = Object.values(router_config)
  .filter((route) => route.isSidebarMenu)
  .map((route) => ({
    id: route.id,
    icon: route.icon,
    name: route.label,
    path: route.path!,
    divider: route.hasDivider || false,
  }))

export const themes = [
  { name: 'Default', theme: 'default' },
  { name: 'Theme 1', theme: 'theme_1' },
]

export const generateArray = (): RouterMenuProps[] => {
  return Object.keys(router_config).map((k) => {
    const obj = router_config[k]
    return { ...obj, slug: k }
  })
}

// type Pages =

export const checkPermissions = (): boolean => {
  return true
}

export const checkPath = () => {
  return '/'
}
